import * as mixpanel from "mixpanel-browser";
import { IEventTrackerProps, UnregisterKeys } from "./EventTrackerConstants";

let actions = {
    register: (props: IEventTrackerProps) => {
        mixpanel.register(props);
    },

    identify: (id: string) => {
        mixpanel.identify(id);
    },
    alias: (id: string) => {
        mixpanel.alias(id);
    },
    track: (name: string, props?: any) => {
        props = props || {};
        // @ts-ignore
        if (name.endsWith("| disabled")) return; // preventing disabled events to be pushed to mix panel
        mixpanel.track(name, { time: new Date(), ...props });
    },
    people: {
        set: (props: any) => {
            mixpanel.people.set(props);
        },
    },
    time_event: (name: string) => {
        if (name.endsWith("| disabled")) return; // preventing disabled events to be pushed to mix panel
        mixpanel.time_event(name);
    },
    pageOpened: (name: string) => {
        if (name.endsWith("| disabled")) return; // preventing disabled events to be pushed to mix panel
        Tracker.time_event(name);
    },
    pageClosed: (name: string, props?: any) => {
        if (name.endsWith("| disabled")) return; // preventing disabled events to be pushed to mix panel
        Tracker.track(name, props || {});
    },

    unregister: (propertyKey: UnregisterKeys) => {
        mixpanel.unregister(propertyKey)
    }
};

export let Tracker = actions;